import { instance } from '../instance'

/**
 * Get notifications list
 * @param params.page
 * @param params.per-page
 * @param params.sort
 * @param params.isViewed
 * @param params.type
 *
 * @return {Promise<AxiosResponse<any>>}
 */
export const getList = async (params = {}) => {
  return instance.get('/v2/notification', { params })
}
